/*eslint-disable*/
import $ from './jquery-3.3.1.min'
import axiosIndex from './axios/index';
import filterIndex from './filter/infoFilter';
import formIndex from './form/index';
import urlsIndex from './urls/url';
import commonJS from './utils/common.js';
import commonApiIndex from './utils/commonApi';
import storeIndex from './store/index';
import { formatDateIndex } from './date/index';

export const  axios = axiosIndex;
export const  filter = filterIndex;
export const  check = formIndex;
export const  urls = urlsIndex;
export const  common = commonJS
export const  commonApi = commonApiIndex;
export const  store = storeIndex;
export const  formatDate = formatDateIndex;
// export const $$ = window.$



// WEBPACK FOOTER //
// ./src/common/index.js